var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VGridform',{attrs:{"name":_vm.blockName,"config":_vm.blockConfig,"callbacks":_vm.blockCallbacks}})}
var staticRenderFns = []

export { render, staticRenderFns }